// Public URLs moved; guideType, slugs and browser progress keys stay unchanged.
function canonicalGuidePath(path) {
  if (typeof path !== 'string') return path;
  const match = path.match(/^(https:\/\/gab\.ai)?\/learn(?=\/|[?#]|$)(\/[^?#]*)?([?#].*)?$/);
  if (!match) return path;
  const [, origin = '', lesson = '', suffix = ''] = match;
  if (lesson && lesson !== '/index' && lesson !== '/') return `${origin}/docs/learn${lesson}${suffix}`;
  const [query, hash] = suffix.split('#');
  return `${origin}/docs${query}#${hash || 'learn'}`;
}

function canonicalGuideLinks(value) {
  if (typeof value === 'string') return canonicalGuidePath(value);
  if (Array.isArray(value)) {
    const mapped = value.map(canonicalGuideLinks);
    return mapped.some((item, index) => item !== value[index]) ? mapped : value;
  }
  if (value && typeof value === 'object' && Object.getPrototypeOf(value) === Object.prototype) {
    const entries = Object.entries(value).map(([key, item]) => [key, canonicalGuideLinks(item)]);
    return entries.some(([key, item]) => item !== value[key]) ? Object.fromEntries(entries) : value;
  }
  return value;
}

module.exports = { canonicalGuidePath, canonicalGuideLinks };
